export const formatPrice = (price: number, useFromPrefix?: boolean) => {
    return `${useFromPrefix ? "Fra\u00A0" : ""}${price.toLocaleString("no")},-`;
};